import { get, includes, isEmpty } from 'lodash'
import { Auth } from 'aws-amplify'
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import adfsAuth from './adfsAuth';
const { publicRuntimeConfig } = require('config');
const { settings } = publicRuntimeConfig;
const AmazonCognitoIdentity = require('amazon-cognito-identity-js');
const CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;

export const setAcessToken = (token) => Promise.resolve(window.localStorage.setItem('auth_token', token))

const removeAccessToken = () => window.localStorage.removeItem('auth_token');

const tokenRefresh = async () => {
  const poolData = {
    UserPoolId : get(settings, 'cognitoPoolIDENV'), // Your user pool id here,
    ClientId: get(settings, 'cognitoClientIDENV')// Your client id here
  };
  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
  const cognitoUser = userPool.getCurrentUser();
  cognitoUser.getSession((err, session) =>{
    const refresh_token = session.getRefreshToken();
    cognitoUser.refreshSession(refresh_token, (refErr, refSession) => {
        if (refErr) {
            throw refErr;
        }
        else{
            //this provide new accessToken, IdToken, refreshToken
            // you can add you code here once you get new accessToken, IdToken, refreshToken
            const token = get(refSession, 'accessToken.jwtToken', null);
            // console.log('newToken', token)
            sessionStorage.setItem('jwtToken', token);
        }
    }); 
  });
}

export const getAccessToken = (refreshToken = false) => {
  return new Promise(async (resolve, reject) => {
    try {
      const credentials = await Auth.currentSession();
      const token = get(credentials, 'accessToken.jwtToken', null);
      sessionStorage.setItem('jwtToken', token);
      resolve(token)
    } catch (error) {
      reject(error)
    }
  })
}

export const getUserInfo = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const credentials = await Auth.currentSession()
      resolve({ credentials })
    } catch (error) {
      reject(error)
    }
  })
}

export const login = ({ username, password }) => {
  const evaluateResponse = (response) => {
    if (get(response, 'challengeName') === 'NEW_PASSWORD_REQUIRED') {
      return Promise.resolve({ status: 'NEW_PASSWORD_REQUIRED' })
    }
    return getAccessToken()
  }
  return Auth
    .signIn(username.toLowerCase(), password)
    .then(evaluateResponse)
}

export const signup = ({ username, password, email, phone_number }) => {
  return Auth.signUp({
    username,
    password,
    attributes: {
      email, // optional
      phone_number, // optional - E.164 number convention
      // other custom attributes
      'custom:att_app_2': String(Math.random())
    },
    validationData: [] // optional
  })
}

export const validateSignupCode = ({ username, code }) => {
  // After retrieving the confirmation code from the user
  return Auth.confirmSignUp(username, code, {
    // Optional. Force user confirmation irrespective of existing alias. By default set to True.
    forceAliasCreation: true
  })
}

export const resendSignupCode = ({ username }) => {
  return Auth.resendSignUp(username)
}

export const forgotPassword = ({ username }) => (Auth.forgotPassword(username))

export const forgotPasswordSubmit = ({ username, code, password }) => (Auth.forgotPasswordSubmit(username, code, password))

export const validateResetPasswordCode = ({ username, password, code }) => {
  return Auth.forgotPasswordSubmit(username, code, password)
}

export const changePassword = ({ username, password, code }) => {
  return Auth.changePassword(username, code, password)
}

export const getCurrentUser = () => {
  return Auth.currentUserInfo()
}

export const completeNewPassword = (username, password, newPassword, phone) => {
  return Auth.signIn(username, password)
    .then(user => {
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        const { requiredAttributes } = user.challengeParam // the array of required attributes, e.g ['email', 'phone_number']
        return Auth.completeNewPassword(
          user, // the Cognito User Object
          newPassword, // the new password
          // OPTIONAL, the required attributes
          {
            phone_number: phone
          }
        ).then(user => {
          // at this time the user is logged in if no MFA required
          return getAccessToken().then(setAcessToken)
        }).catch(e => {
          console.log(e)
        })
      } else {
        // other situations
      }
    }).catch(e => {
      console.log(e)
    })
}

export const logOut = async () => {
  try {
    const res = await Auth.signOut()
    console.log(res)
    removeAccessToken()
    return res
  } catch (error) {
    console.log(error)
    return error
  }
}

export const autoLogout = () => {
  const { isExpired, isWhitelist, ...more } = validateToken();
  const now = moment().format('YYYY-MM-DD');
  // if (includes(['00', '15', '30', '45'], moment().format('ss'))) console.log(isExpired, isWhitelist, more);
  if (moment().isBetween(`${now} 23:00:00`, `${now} 23:59:59`)) {      
  //  adfsAuth.logout(() => window.location.reload());
  }
  if (isExpired && !isWhitelist) {
    sessionStorage.removeItem('jwtToken');
    adfsAuth.logout(() => window.location.reload());
  }
  return;
}

export const validateToken = () => {
  const isWhitelist = includes(
    ['/',
    '/login',
    '/redirect',
    '/forgot-password',
    '/update-password',
    '/change-password',
    'confirm-signup'
  ], window.location.pathname);
  const token = sessionStorage.getItem('jwtToken');
  if (includes(['null', 'undefined'], token) || isEmpty(token)) return;
  const decoded = jwt_decode(token);
  const expires = moment(get(decoded, 'exp', null), 'X').format('DD-MM-YYYY HH:mm:ss');
  const msRemaining = moment(get(decoded, 'exp', null), 'X').diff(moment());
  const isExpired = msRemaining <= 0;
  const refreshWindow = msRemaining > 0 && msRemaining <= 300000;
  const now = moment().format('YYYY-MM-DD');
  if (refreshWindow) {
    tokenRefresh();
  }
  return {
    token,
    isWhitelist,
    decoded,
    expires,
    msRemaining,
    isExpired,
    now: moment().format('DD-MM-YYYY HH:mm:ss')
  };
}
